module.exports = __webpack_public_path__ + "img/20.1f5d796a.jpg";